<script setup lang="ts">
import useCompanyName from '@Use/useCompanyName';
import { ErrorScreenLayout, SupportEmailLink } from '@Shared';
import AuthEndGraphic from '@Assets/images/auth-end.svg';
import AuthErrorShell from '@Components/AuthErrorShell.vue';

const { companyName } = useCompanyName();
</script>

<template>
    <auth-error-shell class="device-throttled-view">
        <div class="device-throttled-view__content">
            <error-screen-layout
                :image="AuthEndGraphic"
                image-alt="Too many attempts"
                title="Too many attempts"
                image-width="5.75rem"
                image-height="6.125rem">
                <p>
                    For security purposes, verification has been temporarily disabled
                    due to multiple incorrect attempts.
                </p>
                <p>
                    {{ companyName }} has been notified. They will reach out directly with next steps.
                    If you have any questions, please contact <support-email-link />.
                </p>
            </error-screen-layout>
        </div>
    </auth-error-shell>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.device-throttled-view {
    @include desktop {
        padding-top: 10.25rem;
        background-color: color-mix(in srgb, $theme-primary-dark 85%, transparent);
    }

    &__content {
        border-radius: 0.25rem;
        background-color: $white;
        max-width: 24.5rem;
        height: 34.25rem;
        max-height: 34.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
        line-height: 150%;
    }
}
</style>
